export enum PhxTheme {
  LIGHT = 'light',
  DARK = 'dark',
  HELIX = 'helix'
  /*DARK_GRAY = 'dark-gray',
  DARK_BLUE = 'dark-blue',
  CASHPRO = 'cashpro', */  
}
